import { useEffect, useRef } from "react";
import { X } from "lucide-react";

type Props = { open: boolean; onClose: () => void };

const sections: { title: string; body: string }[] = [
  {
    title: "1. Coleta de dados pessoais",
    body: "O Meta Gestão Veicular coleta os dados necessários para operar a gestão de frota e o acesso ao sistema: nome, e-mail corporativo e perfil de acesso dos usuários. Nos cadastros operacionais, podem ser tratados nome, matrícula, cargo e dados da habilitação (categoria, número e validade da CNH) de motoristas, além de placa e demais dados dos veículos, documentos anexados e fotos registradas nas vistorias."
  },
  {
    title: "2. Finalidade e uso (Art. 7º da LGPD)",
    body: "Os dados são usados exclusivamente para autenticação, controle de vistorias e conformidade documental, emissão de credenciais veiculares, trilha de auditoria e geração de relatórios operacionais. Não comercializamos seus dados nem os compartilhamos com terceiros não autorizados."
  },
  {
    title: "3. Armazenamento e segurança",
    body: "As informações são armazenadas em infraestrutura de nuvem (Google Firebase, região São Paulo), com autenticação individual, controle de acesso por perfil e registro de auditoria das alterações. O acesso é restrito a usuários autorizados pela Meta Central de Serviços."
  },
  {
    title: "4. Retenção e direitos do titular",
    body: "Os dados são mantidos enquanto houver vínculo ativo com a operação ou obrigação legal de retenção. Você pode solicitar confirmação de tratamento, acesso, correção ou exclusão dos seus dados ao Encarregado de Dados (DPO) da Meta Central de Serviços, observadas as hipóteses legais de guarda."
  },
  {
    title: "5. Concordância",
    body: "Ao marcar a caixa de aceite e entrar na plataforma, você declara ciência desta política e do tratamento dos dados nas finalidades descritas, conforme a Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/2018)."
  }
];

export function PrivacyPolicyDialog({ open, onClose }: Props) {
  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialog = ref.current;
    if (!dialog) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }, [open]);

  return <dialog
    ref={ref}
    className="policy-dialog"
    aria-labelledby="policy-title"
    onClose={onClose}
    onClick={(event) => { if (event.target === event.currentTarget) onClose(); }}
  >
    <div className="policy-dialog-inner">
      <header>
        <h2 id="policy-title">Política de Privacidade e Proteção de Dados (LGPD)</h2>
        <button type="button" className="policy-close" onClick={onClose} aria-label="Fechar"><X size={18} aria-hidden="true"/></button>
      </header>
      <div className="policy-dialog-body">
        {sections.map((section) => <p key={section.title}><strong>{section.title}</strong><br/>{section.body}</p>)}
      </div>
      <footer><button type="button" className="button primary" onClick={onClose}>Fechar e voltar</button></footer>
    </div>
  </dialog>;
}
